import { generateApiPath } from "@routes/generatePath.ts";

const pathBase = `/medical-service-provider/working-times`;

export const workingTimes = {
  get: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
};
